
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexkTCO4CTZD4w1S2XoIeii9GEDkkAet8ltFT741y5lg5QMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/index.vue?macro=true";
import { default as loginSF53_45QD7m0KTHV90cWPhn_45opbZ9U3EhqNdcMYQ4eSaMMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/login.vue?macro=true";
import { default as editorn8ywgXrwyV3P1FsB7mXVJ1WAuzGzDr_qixBi6QhBhKMMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/editor.vue?macro=true";
import { default as reviewf89thjk0lr1OsuBNVN6q7USd_45fQHX_45rYu_MgTDH5Hf0Meta } from "/home/runner/work/RememoWeb/RememoWeb/pages/review.vue?macro=true";
import { default as registerOFZlvurkZ8gvCygxnp_mMm5CefIwgrYZCoBJRPiNJfcMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/register.vue?macro=true";
import { default as indexBcThWIjP0EIDK6lacqHi6hj_45_45BvnYaW30JuDq3H4zCwMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/library/index.vue?macro=true";
import { default as newmXCgXLrfUh78XNHX9FcV5PWlJbbG_5zkYpyiXptR37QMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/library/[deckId]/new.vue?macro=true";
import { default as indexj5nypQkVWyd_OXeZFVcneRWlQTvOzh_zOJ4BwTlQ8tMMeta } from "/home/runner/work/RememoWeb/RememoWeb/pages/library/[deckId]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginSF53_45QD7m0KTHV90cWPhn_45opbZ9U3EhqNdcMYQ4eSaMMeta || {},
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/login.vue")
  },
  {
    name: "editor",
    path: "/editor",
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/editor.vue")
  },
  {
    name: "review",
    path: "/review",
    meta: reviewf89thjk0lr1OsuBNVN6q7USd_45fQHX_45rYu_MgTDH5Hf0Meta || {},
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/review.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerOFZlvurkZ8gvCygxnp_mMm5CefIwgrYZCoBJRPiNJfcMeta || {},
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/register.vue")
  },
  {
    name: "library",
    path: "/library",
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/library/index.vue")
  },
  {
    name: "library-deckId-new",
    path: "/library/:deckId()/new",
    meta: newmXCgXLrfUh78XNHX9FcV5PWlJbbG_5zkYpyiXptR37QMeta || {},
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/library/[deckId]/new.vue")
  },
  {
    name: "library-deckId",
    path: "/library/:deckId()",
    component: () => import("/home/runner/work/RememoWeb/RememoWeb/pages/library/[deckId]/index.vue")
  }
]